module.exports = __webpack_public_path__ + "static/media/hp_ex_public.da8e1dfa.jpg";